import type { IObservableArray } from 'mobx';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { IImportColumn } from '@feathr/blackbox';
import { FieldMappingRowAction } from '@feathr/components';

import type { IImportMappingCellProps } from './ImportMappingTable.utils';

/** The mapping row's remove action, disabled once the import can no longer change. */
function ImportMappingRemoveCell({
  column,
  importer,
  disabled,
}: Readonly<IImportMappingCellProps>): JSX.Element {
  const { t } = useTranslation();

  function handleRemove(): void {
    runInAction(() => {
      (importer.get('column_mappers') as IObservableArray<IImportColumn>).remove(column);
    });
    importer.setAttributeDirty('column_mappers');
  }

  return (
    <FieldMappingRowAction
      isLocked={false}
      onRemove={handleRemove}
      removeDisabledReason={disabled ? t('This import can no longer be changed.') : undefined}
    />
  );
}

export default observer(ImportMappingRemoveCell);
